import styled from 'styled-components'
import { Spacing, Inset, Colors, Media } from '@doordash/design-language'

export const Container = styled.div`
  padding-left: ${Spacing.Small}px;
  padding-right: ${Spacing.Small}px;
`

export const MailingAddressFormContainer = styled.div`
  padding-left: ${Spacing.Small}px;
  padding-right: ${Spacing.Small}px;
  padding-bottom: 32px;
  overflow-y: scroll;
  height: calc(100% - 136px);
  ${Media.Tablet`
    padding-bottom: ${Spacing.XxxLarge}px;
  `}
`

export const NonDismissableMailingAddressFormContainer = styled.div`
  padding-left: ${Spacing.Small}px;
  padding-right: ${Spacing.Small}px;
  ${Media.Tablet`
    padding-bottom: 88px;
  `}
`

export const Bottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${Spacing.Large}px;
  z-index: 1;
  background-color: ${Colors.SystemWhite};
`
export const ClearPadding = styled.div`
  padding: 0;
`

export const ImageContainer = styled.div`
  svg {
    width: 100%;
  }
`
export const TitleContainer = styled(Inset)`
  padding-top: 0;
`
